import { defineMessages } from 'react-intl';

export const shippingMethodField = defineMessages({
    shippingMethodLabel: {
        id: 'form.fields.shippingMethodLabel',
        description: 'Shipping method input label',
        defaultMessage: 'Shipping'
    }
});

export const agreeToTermsFieldMessages = defineMessages({
    policyAndAgreementLinks: {
        id: 'form.fields.policyAndAgreementLinks',
        description: 'Text beside a checkbox for agreement with the terms of service and the privacy policy',
        defaultMessage:
            'I agree to the <terms>terms of service</terms> and <policy>privacy policy</policy>'
    }
});

export const termsAgreementInfoFieldMessages = defineMessages({
    policyAndAgreementLinks: {
        id: 'form.fields.policyAndAgreementLinksInfo',
        description: 'Text for agreement with the terms of service and the privacy policy',
        defaultMessage:
            'By completing your order, you agree to the Blackhawk Network <terms>Terms of Use</terms> and <policy>Privacy Policy</policy>. ' +
            'You also acknowledge that the prepaid cards offered through this site are sold by Blackhawk Network, Inc.'
    }
});

export const quantityFieldMessages = defineMessages({
    quantityShort: {
        id: 'forms.fields.quantityShort',
        description: 'Short inline label for the gift card quantity on the line item',
        defaultMessage: 'QTY'
    }
});

export const giftCardFieldMessages = defineMessages({
    senderNameFieldLabel: {
        id: 'form.fields.senderNameFieldLabel',
        description: 'Sender name input label',
        defaultMessage: 'Your Name'
    },
    recipientNameFieldLabel: {
        id: 'form.fields.recipientNameFieldLabel',
        description: 'Recipient name input label',
        defaultMessage: 'Recipient Name'
    },
    recipientEmailFieldLabel: {
        id: 'form.fields.recipientEmailFieldLabel',
        description: 'Recipient email input label',
        defaultMessage: 'Recipient Email'
    },
    amountFieldLabel: {
        id: 'form.fields.amountFieldLabel',
        description: 'Amount input label',
        defaultMessage: 'Amount'
    },
    amountIncrement: {
        id: 'form.fields.amountIncrement',
        description: 'Amount increment button label',
        defaultMessage: 'Increment Amount'
    },
    amountDecrement: {
        id: 'form.fields.amountDecrement',
        description: 'Amount decrement button label',
        defaultMessage: 'Decrement Amount'
    },
    amountRange: {
        id: 'form.fields.amountRange',
        description: 'Range of amount values description',
        defaultMessage: 'Range: ${min} - ${max}'
    },
    denominationLabel: {
        id: 'form.fields.denominationLabel',
        description: 'Pre-denomiated amount input label',
        defaultMessage: 'Denomination'
    },
    messageFieldLabel: {
        id: 'form.fields.messageFieldLabel',
        description: 'Message text input label',
        defaultMessage: 'Message (optional)'
    },
    deliveryDateFieldLabel: {
        id: 'form.fields.deliveryDateFieldLabel',
        description: 'Delivery date field label',
        defaultMessage: 'Delivery Date'
    },
    messageCounterAria: {
        id: 'form.fields.messageCounterAria',
        description: 'Message counter aria label',
        defaultMessage: 'message length {current} of {maxLength}'
    }
});
